import React, { useEffect, useState } from 'react';
import { Card, Grid } from 'tabler-react';
import './Discipline.scss';
import MoonLoader from 'react-spinners/MoonLoader';
import { useAPI } from '../../ApiCalls/useAPI';
import RemoveLastDirectoryPartOf from '../goBackButton';

export default function Discipline() {
    const [data, setData] = useState([]);
    const { getDiscipline } = useAPI();

    useEffect(() => {
        getDiscipline()
            .then((response) => {
                // console.log(response);
                setData(response);
            })
            .catch((error) => console.error(error));
    }, []);

    const FirstTab = () => {
        return (
            <div className="FirstTab">
                <Grid.Row>
                    <Grid.Col xl={6} lg={6} md={6} sm={6} xs={12}>
                        <div>
                            <div className="card" style={{ backgroundColor: `${data.color}`, color: 'white' }}>
                                <div
                                    style={{ padding: '5px' }}
                                    className="card-body text-center"
                                >
                                    <div className=" mb-1">Points</div>
                                    <div>
                                        {data.points.score} out of{' '}
                                        {data.points.maxscore}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid.Col>
                    <Grid.Col xl={6} lg={6} md={6} sm={6} xs={12}>
                        <div>
                            <div className="card">
                                <div
                                    style={{ padding: '5px' }}
                                    className="card-body text-center"
                                >
                                    <div className=" mb-1">Exceeded Ten</div>
                                    <div>{data.cycle} times</div>
                                </div>
                            </div>
                        </div>
                    </Grid.Col>
                </Grid.Row>
                <Card
                    title="Recent"
                    body={
                        data.comments.length === 0 ? (
                            <div>No comments Found</div>
                        ) : (
                            data.comments.map((item) => {
                                return (
                                    <div>
                                        <div>{item.recent}</div>
                                        <div>{item.comment}</div>
                                        <br></br>
                                    </div>
                                );
                            })
                        )
                    }
                />
            </div>
        );
    };
    const SecondTab = () => {
        if (data.punishment === null) {
            return (
                <div className="SecondTab">

                    <Card className="mt-4 p-4 text-center">NO DATA FOUND</Card>
                </div>
            );
        }
        return (
            <div className="SecondTab">
                <div className="container">
                    <Card
                        title="Punishments"
                        body={data.punishments.map((item) => {
                            return (
                                <div>
                                    <div>{item.updateddate}</div>
                                    <div
                                        style={{
                                            color: `${item.status.color}`
                                        }}
                                    >
                                        {item.status}
                                    </div>
                                    <div>{item.date}</div>
                                    <div>{item.description}</div>
                                    <br></br>
                                </div>
                            );
                        })}
                    />
                </div>
            </div>
        );
    };

    const Tabs = () => {
        const [activeTab, setActiveTab] = useState('tab1');
        const handleTab1 = () => {
            setActiveTab('tab1');
        };
        const handleTab2 = () => {
            setActiveTab('tab2');
        };
        return (
            <div className="Tabs">
                <ul className="navtab">
                    <li
                        className={activeTab === 'tab1' ? 'active' : ''}
                        onClick={handleTab1}
                    >
                        Violations
                    </li>
                    <li
                        className={activeTab === 'tab2' ? 'active' : ''}
                        onClick={handleTab2}
                    >
                        Punishments
                    </li>
                </ul>
                <div className="outlet">
                    {activeTab === 'tab1' ? <FirstTab /> : <SecondTab />}
                </div>
            </div>
        );
    };

    const override = `
            display: block;
            margin: 10% auto;
            border-color: red;
        `;

    if (data.length === 0) {
        return (
            <div>
                <h1 className="mt-4" style={{ textAlign: 'center' }}>
                    Waiting for data ...
                </h1>
                <MoonLoader
                    color={'green'}
                    isLoading={true}
                    css={override}
                    size={60}
                />
            </div>
        );
    }
    return (
        <div className="container">
            <div
                className="m-2 mt-4"
                style={{ fontSize: '20px', display: 'flex' }}
            >
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>Discipline</div>
            </div>
            <Tabs></Tabs>
        </div>
    );
}
